import React from 'react';

import { Tooltip, Nav, OverlayTrigger } from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

import Flex from 'components/common/Flex';

import styles from 'assets/scss/wizard/wizardLayoutEmet.module.scss';

const NavItemPill = ({
	index,
	step,
	handleNavs,
	icon,
	label,
	sectionDesc
}) => {
	const sectionTooltip = (
		<Tooltip id="tooltip" className={styles.customTooltip}>
			{sectionDesc} 
        </Tooltip>
	);
	
    return (
		<Nav.Item> {
			label.trim() !== 'BREAK' && (
				<OverlayTrigger placement="bottom" overlay={sectionTooltip}>
					<Nav.Link className={classNames('fw-semi-bold', {done: step > index, active: step === index})}
						onClick={() => handleNavs(index)} >
						<Flex alignItems="center" justifyContent="center">
							<FontAwesomeIcon icon={icon} />
							<span className="d-none d-md-block mt-1 fs--1 ms-2">{label}</span>
						</Flex>
					</Nav.Link>
				</OverlayTrigger>
			)}
            {label.trim() === 'BREAK' && (
                <Nav.Link className={classNames('fw-semi-bold', {done: step > index, active: step === index})}
                    onClick={() => handleNavs(index)} >
                    <Flex alignItems="center" justifyContent="center">
                        <FontAwesomeIcon icon={icon} />
                        <span className="d-none d-md-block mt-1 fs--1 ms-2">{label}</span>
                    </Flex>
                </Nav.Link>
            )} 
        </Nav.Item>
	);
};

export default NavItemPill;